import { FormFieldTypeDTO } from '@/api/base/DTOs';
import { adaptFormFieldResponseToCheckboxFormField } from '../field-types/checkbox-field.adapter';
import { adaptFormFieldResponseToDateFormField } from '../field-types/date-field.adapter';
import { adaptFormFieldResponseToInputFormField } from '../field-types/input-field.adapter';
import { adaptFormFieldResponseToRadioGroupFormField } from '../field-types/radio-group-field.adapter';
import { adaptFormFieldResponseToSelectFormField } from '../field-types/select-field.adapter';
import { adaptFormFieldResponseToTextAreaFormField } from '../field-types/textarea-field.adapter';
import { singleFormFieldAdapterRegistry } from './single-form-field-adapter.registry';

singleFormFieldAdapterRegistry
  .setPrimitiveAdapters({
    toInput: adaptFormFieldResponseToInputFormField,
    toRadioGroup: adaptFormFieldResponseToRadioGroupFormField,
    toSelect: adaptFormFieldResponseToSelectFormField,
  })
  .register(FormFieldTypeDTO.TextArea, adaptFormFieldResponseToTextAreaFormField)
  .register(FormFieldTypeDTO.Boolean, adaptFormFieldResponseToCheckboxFormField)
  .register(FormFieldTypeDTO.Date, adaptFormFieldResponseToDateFormField);
